<template>
  <div id="integrationsOverview" class="margin-subpages">
    <div id="integrationStutus">
      <div class="sub-title">{{ $t("integrations.INTEGRATION_STATUS") }}</div>
      <div class="line-style mt-16" style="margin-bottom: 43px" />
      <div class="contriner-integration">
        <div class="card-integration">
          <img
            class="logo-integratioin"
            src="@/assets/images/integrations/icon_hris_sync@2x.png"
            alt="HRIS Sync"
          />
          <div class="flex-center menu">
            <div class="px-16">
              <div class="title">{{ $t("integrations.HRIS_Sync") }}</div>
              <div class="description">
                {{ $t("integrations.Sync_your_employee_data") }}
              </div>
            </div>
          </div>
          <div class="flex-center">
            <el-button
              v-if="hrisSync == 'conected'"
              @click="onClickButton('hrisSync')"
              class="conected"
              >{{ $t("integrations.Connected") }}</el-button
            >
            <el-button v-else @click="onClickButton('hrisSync')" class="gray">{{
              $t("integrations.Setup")
            }}</el-button>
          </div>
        </div>
        <div class="card-integration">
          <img
            class="logo-integratioin"
            src="@/assets/images/integrations/icon_API@2x.png"
            alt="icon API"
          />
          <div class="flex-center menu">
            <div class="px-16">
              <div class="title">{{ $t("integrations.Developer_API") }}</div>
              <div class="description">
                {{ $t("integrations.Activate_your_developer") }}
              </div>
            </div>
          </div>
          <div class="flex-center">
            <el-button
              v-if="api == 'conected'"
              @click="onClickButton('api')"
              class="conected"
              >{{ $t("integrations.Connected") }}</el-button
            >
            <el-button v-else @click="onClickButton('api')" class="gray">{{
              $t("integrations.Setup")
            }}</el-button>
          </div>
        </div>
        <div class="card-integration">
          <img
            class="logo-integratioin"
            src="@/assets/images/integrations/icon_SSO@2x.png"
            alt="icon SSO"
          />
          <div class="flex-center menu">
            <div class="px-16">
              <div class="title">{{ $t("integrations.SSO_Title") }}</div>
              <div class="description">{{ $t("integrations.SSO_Desc") }}</div>
            </div>
          </div>
          <div class="flex-center">
            <el-button
              v-if="selectedSso.enabled"
              @click="onClickButton('sso')"
              class="conected"
              >{{ $t("integrations.Connected") }}</el-button
            >
            <el-button v-else @click="onClickButton('sso')" class="gray">{{
              $t("integrations.Setup")
            }}</el-button>
          </div>
        </div>
        <!-- <div class="card-integration">
          <div class="logo-integratioin"></div>
          <div class="flex-center menu">
            <div class="px-16">
              <div class="title">GSuite</div>
              <div class="description">Add Google Calendar events and Google Meets links to University Sessions</div>
            </div>
          </div>
          <el-button class="conected">{{ $t('integrations.Connected') }}</el-button>
        </div> -->
        <!-- <div class="card-integration">
          <div class="logo-integratioin"></div>
          <div class="flex-center menu">
            <div class="px-16">
              <div class="title">MS Teams</div>
              <div class="description">Add MS Calendar events and MS Team links to University Sessions</div>
            </div>
          </div>
          <el-button class="gray">{{ $t('integrations.Setup') }}</el-button>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "overview",
  created() {},
  computed: {
    selectedSso() {
      return this.$store.getters["integrations/selectedSso"];
    },
  },
  data() {
    return {
      hrisSync: "conected",
      api: "default",
      sso: "default",
    };
  },
  methods: {
    onClickButton(event) {
      this.$emit("clicked", event);
    },
  },
};
</script>

<style lang="scss" scoped>
.card-integration {
  display: grid;
  grid-template-columns: 64px auto 113px;
  margin: 16px 0;
}
.logo-integratioin {
  border-radius: 6px;
  width: 64px;
  height: 64px;
}
.menu {
  .title {
    color: #4a4a4a;
    font-weight: 700;
    font-size: 18px;
    padding-bottom: 2px;
  }
  .description {
    color: #9d9d9d;
    font-size: 16px;
  }
}
</style>

<style lang="scss">
#integrationStutus .el-button {
  border-radius: 3px;
  height: 42px;
  width: 113px;
  margin: auto;
  font-weight: 700;
  transition: 0.2s;
}
#integrationStutus .el-button.gray {
  background-color: #fff;
  border-color: #c9c9c9;
  color: #747474;
  &:hover {
    background-color: rgb(240, 240, 240);
  }
}
#integrationStutus .el-button.conected {
  background-color: #32c2d5;
  border-color: #32c2d5;
  color: #fff;
  &:hover {
    background-color: #2fb4c5;
  }
}
</style>